import { isEmpty } from 'lodash'
export default {
  data(){
    return {
      expanded : false
    }
  },
  created(){
    this.$events.$on('close-facets-'  + this.$parent.name, () => {
      this.expanded = false
    });
  
    if(!isEmpty(this.value)){
      this.selected = this.value
    }
  },
  methods : {
    expand(){
      if(!this.expanded){
        this.$events.$emit('close-facets-' + this.$parent.name)
      }
      
      this.expanded = !this.expanded;
    }
  },
}